import Axios from "axios";
import type { AxiosInstance } from "axios";
const axios: AxiosInstance = Axios.create();
axios.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    console.error(error);
  }
);

export default axios;
